export default "__VITE_ASSET__7687a8ad__"